import { Space } from 'antd';
import { useContext } from 'react';

import { VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const VisitsRecordsExistenceLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  return (
    <Space
      className={`visits-records-existence-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>Наличие записей</span>
      <ClientFilterTag
        filters={filters}
        serverFilters={serverFilters}
        filtersArea={VISITS_FILTER}
        filterGroupIndex={filterGroupIndex}
        setFilters={setFilters}
        setServerFilters={setServerFilters}
        valueKey={
          'HasRecords' as keyof NClientsList.VisitsFilterUnitValue['HasRecords']
        }
      >
        {serverFilters.VisitsFilter?.[filterGroupIndex]?.Values?.[0]?.HasRecords
          ? 'Есть записи'
          : 'Нет записей'}
      </ClientFilterTag>
    </Space>
  );
};
